import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/styles/global.scss'
import './utils/h5Uni'  // H5兼容uni-api

Vue.use(Vant)

Vue.config.productionTip = false

// 启动时清理上一会话残留的缓存：下车点 endLocation + 人数等 QR 上下文 ticketQrContext。
// 移动端 beforeunload 在关闭浏览器/杀进程时不触发，改为启动时清理。
// 登录回跳用 reLaunch(=reload)，sessionStorage 的 ticketReturning 标记会跨 reload 保留：
// 有标记说明是登录回跳/子页返回，跳过清理以保留上下文；无标记视为新会话，清掉上次残留。
if (!window.sessionStorage.getItem('ticketReturning')) {
  try {
    window.localStorage.removeItem('endLocation')
    window.localStorage.removeItem('ticketQrContext')
  } catch (e) { /* ignore */ }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')